import {Button, ButtonGroup} from 'platform/components';
import {Heading, VStack} from 'platform/foundation';

import {usePutWarehouseHeaderDynamicActionsMutation} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

interface EmptyServiceOrderReturnDialogProps {
  onDelete: VoidFunction;
  onDontDelete: VoidFunction;
}

export function EmptyServiceOrderReturnDialog(props: EmptyServiceOrderReturnDialogProps) {
  const [, {isLoading}] = usePutWarehouseHeaderDynamicActionsMutation({
    fixedCacheKey: 'sor-basket-action',
  });

  return (
    <VStack spacing={4}>
      <Heading size={4}>
        {i18n.t('entity.warehouse.labels.emptyServiceOrderReturnDeletePrompt')}
      </Heading>
      <ButtonGroup align="right">
        <Button
          isLoading={isLoading}
          variant="secondary"
          title={i18n.t('entity.warehouse.actions.dontDelete')}
          onClick={props.onDontDelete}
        />
        <Button
          isLoading={isLoading}
          variant="danger"
          title={i18n.t('entity.warehouse.actions.delete')}
          onClick={props.onDelete}
        />
      </ButtonGroup>
    </VStack>
  );
}
